// extracted by mini-css-extract-plugin
export var priceSlider = "PriceSlider-module--price-slider--WCqP2";
export var priceSliderLabel = "PriceSlider-module--price-slider-label--31Fva";
export var priceSliderSlider = "PriceSlider-module--price-slider-slider--1Wkw9";